import { Category } from '@/types';

export class CategoryEntity {
  categoryLabel: string;
  categoryQuery: string;
  internalPictureURL: string;
  order: number;

  constructor(category: Category) {
    this.categoryLabel = category.categoryLabel;
    this.categoryQuery = category.categoryQuery;
    this.internalPictureURL = category.internalPictureURL;
    this.order = category.order;
  }
}
